import _ from 'lodash';
import error from 'aurora-utils/error';
import * as types from './constants';

const defaultState = {
  loading: false,
  user: null,
  activeProperty: null,
  error,
  legalForms: [],
  licenseSource: [],
  permissions: {},
};

export default function userReducer(state = defaultState, action = {}) {
  switch (action.type) {
    case types.FETCH_PROFILE:
      return {
        ...state,
        query: _.get(action.payload, 'query'),
        loading: true,
      };
    case types.FETCH_PROFILE_SUCCESS:
      return {
        ...state,
        loading: false,
        user: action.payload,
        error,
      };
    case types.FETCH_PROFILE_ERROR:
      return {
        ...state,
        loading: false,
        user: null,
        error: _.get(action.payload, 'error'),
      };

    //
    case types.EDIT_PROFILE:
      return {
        ...state,
        // user: _.get(action.payload, 'query'),
        loading: true,
      };
    case types.EDIT_PROFILE_SUCCESS:
      return {
        ...state,
        loading: false,
        user: action.payload,
        error,
      };
    case types.EDIT_PROFILE_ERROR:
      return {
        ...state,
        loading: false,
        user: null,
        error: _.get(action.payload, 'error'),
      };
    // profile look up
    case types.FETCH_LOOKUP_PROFILE_SUCCESS:
      return {
        ...state,
        loading: false,
        legalForms: _.get(action.payload, 'legalForms'),
        licenseSource: _.get(action.payload, 'licenseSources'),
        error,
      };
    // switch profile
    case types.SWITCH_PROFILE:
      return {
        ...state,
        query: _.get(action.payload, 'query'),
        loading: true,
      };
    case types.SWITCH_PROFILE_SUCCESS:
      return {
        ...state,
        loading: false,
        // user: action.payload,
        error,
      };
    case types.SWITCH_PROFILE_ERROR:
      return {
        ...state,
        loading: false,
        user: null,
        error: _.get(action.payload, 'error'),
      };
    case types.CLEAR_USER_PROFILE_ERROR:
      return {
        ...state,
        error: null,
      };

    case types.DOWNLOAD_DOCUMENT_LOADING:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.DOWNLOAD_DOCUMENT_SUCCESS: {
      return {
        ...state,
        loading: false,
      };
    }
    case types.DOWNLOAD_DOCUMENT_ERROR:
    case types.PERMISSION_ERROR:
      return {
        ...state,
        loading: false,
        error: _.get(action.payload, 'error'),
      };
    case types.PERMISSION_SUCCESS:
      return {
        ...state,
        loading: false,
        permissions: {
          ...(action.payload && typeof action.payload === 'object' ? action.payload : {}),
        },
      };
    default:
      return state;
  }
}
